import stacyOnTableArousedBG from'../images/stacyOnTableArousedBG.png'
import stacyOnTableArousedRightBG from'../images/stacyOnTableArousedRightBG.png'
import stacyOnTableArousedLeftBG from'../images/stacyOnTableArousedLeftBG.png'
import stacyOnTableUnarousedLeftBG from'../images/stacyOnTableUnarousedLeftBG.png'
import stacyOnTableUnarousedRightBG from'../images/stacyOnTableUnarousedRightBG.png'
import stacyOnTableUnarousedBG from'../images/stacyOnTableUnarousedBG.png'
import classroomMainCutAfterOrgasm from'../images/classroomMainCutAfterOrgasm.png'
import classroomMainSlide6_bg from'../images/classroomMainSlide6_bg.png'
import classroomTables_bg from'../images/classroomTables_bg.png'
import stacyAfterOrgasm from'../images/stacyAfterOrgasm.png'
import stacyGettingNaked from'../images/stacyGettingNaked.png'
import wipingDeskBG from'../images/wipingDeskBG.gif'
import stacyClitorisQuestion from'../images/stacyClitorisQuestion.gif'
import stacyClitorisQuestionBG from'../images/stacyClitorisQuestionBG.png'
import stacyTouchingTits from'../images/stacyTouchingTits.gif'
import stacyButtPetting from'../images/stacyButtPetting.gif'
import stacyTeachMasturbation1 from'../images/stacyTeachMasturbation1.png'
import stacyTeachMasturbation2 from'../images/stacyTeachMasturbation2.gif'
import stacyTeachMasturbation3 from'../images/stacyTeachMasturbation3.png'
import ryderInsta from'../images/ryderInsta.png'
import willieChat from'../images/willieChat.png'
import howardChat from'../images/howardChat.png'
import stacyChat from'../images/stacyChat.png'
import phoebeChat from'../images/phoebeChat.png'
import chatCover from'../images/chatCover.png'
import characters from'./characters';
import achievements from'./achievements';
import gallery from'./gallery';


const chapter2 = [

  {novel:true, background:classroomMainSlide6_bg, startCoordinates:40,
  script:[
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1.5,
    phrases:[
      {text:"All right, time's up! Hand the tests over to me and let's move on to the practical part", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Today's practice is going to be about female orgasm and petting.", emotion:characters["profryder"].standingNeutral},
      {text:"All right, I need 2 volunteers...", emotion:characters["profryder"].standingNeutral},
      {text:"And I have to tell you, today’s activity is going to be.. highly involving", emotion:characters["profryder"].standingLaughing},
      {text:"Anyone?", emotion:characters["profryder"].standingQuestion},
    ]
    },
    {char:characters["violet"],  position:"left", coordinates: 40, speed:1.3,
    phrases:[
      {text:"Hi... Hello...", emotion:characters["violet"].shy},
      {text:"Sorry I'm late.", emotion:characters["violet"].shyEyesDown},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1,
    phrases:[
      {text:"Good afternoon! That's okay", emotion:characters["profryder"].standingSmiling},
      {text:"But you’re gonna need to go through the presentation at home", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"And you’ll have to write the test in the next class", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Though looking at the number of books you’ve got there.. you could’ve taught the class yourself, haha", emotion:characters["profryder"].standingLaughing},
      {text:"What's this one?", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"‘She comes first’, oh yeah, highly recommended!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {char:characters["violet"],  position:"left", coordinates: 40, speed:1,
    phrases:[
      {text:"S-sure, I’ll write the test later..", emotion:characters["violet"].shyEyesDown},
      {text:"Can I sit down?", emotion:characters["violet"].neutral},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1,
    phrases:[
      {text:"Yes, but wait, maybe you'd like to volunteer?", emotion:characters["profryder"].standingSmiling},
      {text:"We're about to start our practical part", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["violet"],  position:"left", coordinates: 40, speed:1,
    phrases:[
      {text:"Oh, uh– um..", emotion:characters["violet"].shyEyesDown},
      {text:"I don't even know..", emotion:characters["violet"].shy},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1,
    phrases:[
      {text:"Or maybe you’d like to observe first?", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {char:characters["violet"],  position:"left", coordinates: 40, speed:1,
    phrases:[
      {text:"Um, yes", emotion:characters["violet"].shy},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1,
    phrases:[
      {text:"All right.", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Hmmm", emotion:characters["profryder"].standingQuestion},
      {text:"Phoebe, would you like to?", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {endOfNovel:true}
  ]
  },
  {novel:true, background:classroomTables_bg, startCoordinates:20,
  script:[
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:0.4,
    phrases:[
      {text:"Me?", emotion:characters["phoebe"].sittingSurprisedCoffee},
      {text:"I don't know. I'd rather...", emotion:characters["phoebe"].sittingThinkingBlushedCoffee},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"I think you'd be great at it!", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"C’mon c’mon it'd be super cool!!", emotion:characters["willie"].sittingNeutral},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"I don't...", emotion:characters["phoebe"].sittingQuestionCoffee},
    ]
    },
    {char:characters["ursula"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"She's always such a coward", emotion:characters["ursula"].sittingDisgusted},
    ]
    },
    {char:characters["everyone"],  position:"center", coordinates: 5, speed:0.7,
    phrases:[
      {text:"Phoebe! Phoebe!"},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"I... I...", emotion:characters["phoebe"].sittingSadTearsCoffee, answers:["Step in", "Phoebe! Phoebe!"]},
    ]
    },
    {option:"Step in", start:true},
    {char:characters["dick"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Stop pushing her!", emotion:characters["dick"].sittingAngry, achievement:achievements[7]},
      {text:"She said she didn't want to!", emotion:characters["dick"].sittingAngry},
      {text:"Isn't that enough?!", emotion:characters["dick"].sittingAngry},
    ]
    },
    {char:characters["ursula"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"<small><i>Looks like sis has gotten herself a protector haha</small></i>", emotion:characters["ursula"].sittingWhatever},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Richard, you're absolutely right, that’s enough!", emotion:characters["profryder"].standingNeutral},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Thank you...", emotion:characters["phoebe"].sittingSadCoffee},
    ]
    },
    {option:"Step in", endOfOption:true},

    {option:"Phoebe! Phoebe!", start:true},
    {char:characters["dick"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Phoebe, Phoebe!", emotion:characters["dick"].sittingNeutral},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Stop pushing me!", emotion:characters["phoebe"].sittingAngryTearsCoffee},
      {text:"I said I wasn’t ready!", emotion:characters["phoebe"].sittingAngryTearsCoffee},
      {text:"Jesus. Is it really so hard to hear me?", emotion:characters["phoebe"].sittingFrustratedTearsCoffee},
      {text:"I JUST don't want to!", emotion:characters["phoebe"].sittingAngryTearsCoffee},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Phoebe, I apologize. I should have stopped this sooner", emotion:characters["profryder"].standingNeutral},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"I want to be alone, just don't touch me!", emotion:characters["phoebe"].sittingFrustratedTearsCoffee},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Yes, sure", emotion:characters["profryder"].standingNeutral},
    ]
    },
    {option:"Phoebe! Phoebe!", endOfOption:true, endOfOptions:true},

    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Guys, that's a rule I live by", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"And especially in sex it’s crucial", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"If someone doesn't want to do something, don't try to talk them into it or make them do it.", emotion:characters["profryder"].standingNeutral},
    ]
    },
    {char:characters["howard"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"What if she's doing it all just to humiliate me, to deprive me of my basic needs?", emotion:characters["howard"].sittingNeutral},
      {text:"What if she's just playing hard to get?", emotion:characters["howard"].sittingNeutral},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Oh, Howard, I understand how painful it could be to feel rejected", emotion:characters["profryder"].standingNeutral},
      {text:"But intimacy isn't something anyone owes another person", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"It's respect and trust that we share with them", emotion:characters["profryder"].standingSmiling},
      {text:"It's something that's really hard to achieve, we are all so different", emotion:characters["profryder"].standingSmiling},
      {text:"But viewing it as an obligatory action will just harm both people involved", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"So when a person is saying no to you, that just means no. No matter the reason behind it we should respect it", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Shit I’m sorry Phoebe, I was just... trying to be supportive, I guess", emotion:characters["willie"].sittingSerious},
      {text:"I should’ve shut up when you said no...", emotion:characters["willie"].sittingSerious},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Oh, come on, forget it", emotion:characters["phoebe"].sittingNeutralCoffee},
      {text:"Wow you are good at.. apologizing, man", emotion:characters["phoebe"].sittingSmilingCoffee},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"So, where were we? Um, yeah", emotion:characters["profryder"].standingQuestion},
      {text:"Still need a volunteer!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {char:characters["empty"],  position:"center", coordinates: 10, speed:1,
    phrases:[
      {text:"*Silence*"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Guys, don't make me do it myself... I mean, I want you to gain some proper experience!", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["ursula"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"<small><i>Looks like I'm gonna have to save this losers club</small></i>", emotion:characters["ursula"].sittingWhatever},
    ]
    },
    {char:characters["stacy"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"I want to go!", emotion:characters["stacy"].sittingNeutral},
    ]
    },
    {char:characters["ursula"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Huh, you’re such a nympho..", emotion:characters["ursula"].sittingNeutral},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Stacy, you're gonna have to undress below the waist for this part.", emotion:characters["profryder"].standingBlushed},
    ]
    },
    {char:characters["stacy"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Oooh, easily...", emotion:characters["stacy"].sittingNeutral},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"And we also need a partner for you, so please pick them yourself", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Someone you’re going to really be comfortable with", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["howard"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Pick me! Pick me!", emotion:characters["howard"].sittingSnide},
    ]
    },
    {char:characters["stacy"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Hmm. Comfortable.. Well, um...", emotion:characters["stacy"].sittingNeutral},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"<small><i>Hey dude, Fortnut tonight?</small></i>", emotion:characters["willie"].sittingSnide},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"<small><i>Yeah, sure</small></i>", emotion:characters["dick"].sittingNeutral},
    ]
    },
    {char:characters["stacy"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Dick!", emotion:characters["stacy"].sittingNeutral},
      {text:"Dick, would you like to join me?", emotion:characters["stacy"].sittingNeutral},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"<small><i>What? Didn't hear you</small></i>", emotion:characters["willie"].sittingSnide},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"YES!", emotion:characters["dick"].sittingNeutral},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"THAT'S the spirit.", emotion:characters["profryder"].standingLaughing},
      {text:"All right, Stacy, can you get ready?", emotion:characters["profryder"].standingSmiling},
      {text:"Oh, guys, and we're gonna need your hands clean, you can get wet wipes in my drawer", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {scene:true, img:stacyGettingNaked, start:true, time:300, gallery:gallery[11]},
    {scene:true, name:characters["empty"].name, position:"center",
    phrases:[
      {text:"Oh my god... Am I gonna touch her?!"}
    ]},
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {endOfNovel:true}
  ]
  },

  {novel:true, background:stacyOnTableUnarousedRightBG, startCoordinates:20,
  script:[
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, gallery:gallery[12]},
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Look at that nice pussy...", emotion:characters["profryder"].standingBlushed},
      {text:"I mean... that's a.. great vulva!", emotion:characters["profryder"].standingLaughing},
      {text:"All right, let's start by finding the clitoris", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Richard, can you show me where the clitoris is, please?", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {scene:true, img:stacyClitorisQuestion, img2:stacyClitorisQuestionBG, start:true, time:300, dialogCoordinates:"78vh", gallery:gallery[13]},
    {scene:true, name:characters["dick"].name, position:"left",
    phrases:[
      {text:"It is the..", answers:["First option", "Second option","Third option"]},
    ]},
    {option:"First option", start:true},
    {scene:true, name:characters["profryder"].name, position:"right", dialogCoordinates:"60vh",
    phrases:[
      {text:"Almost, that's what covers it, the hood of the clitoris", achievement:achievements[8]},
      {text:"Don't worry, it's easy to confuse, the clitoris is right here."},
    ]},
    {option:"First option", endOfOption:true},

    {option:"Second option", start:true},
    {scene:true, name:characters["profryder"].name, position:"right", dialogCoordinates:"60vh",
    phrases:[
      {text:"Yeah, that's right!", achievement:achievements[9]},
      {text:"Well done!"},
    ]},
    {option:"Second option", endOfOption:true},

    {option:"Third option", start:true},
    {scene:true, name:characters["profryder"].name, position:"right", dialogCoordinates:"60vh",
    phrases:[
      {text:"That's the urethra, the clitoris is just above it", achievement:achievements[8]},
      {text:"Don't worry, it's not always easy to find"},
    ]},
    {option:"Third option", endOfOption:true, endOfOptions:true},
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},

    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"As you can remember the clitoris is responsible for...", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {char:characters["willie"],  position:"center", coordinates: 70, speed:1,
    phrases:[
      {text:"Female orgasm!"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Right!", emotion:characters["profryder"].standingLaughing},
      {text:"Unlike the male orgasm, it's much more related to the PSYCHOlogical state than to the PHYSIOlogical state", emotion:characters["profryder"].standingSmiling},
      {text:"Therefore, despite what porn teaches us, it is not always possible to achieve orgasm for a woman and it is normal", emotion:characters["profryder"].standingSmiling},
      {text:"To do this, the partner and the girl will usually have to sweat a lot haha", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {char:characters["howard"],  position:"center", coordinates: 70, speed:1,
    phrases:[
      {text:"If it doesn't work, it's a bad fuck!!"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Again, Howard, that's not true", emotion:characters["profryder"].standingNeutral},
      {text:"Sometimes achieving orgasm can be complicated by additional factors", emotion:characters["profryder"].standingNeutral},
      {text:"Anxiety, poor communication, using an overly stimulating masturbation method in the past", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Actually, having faced such difficulties myself, I ended up here teahing you!", emotion:characters["profryder"].standingLaughing},
	    {text:"Meanwhile, for some women not having orgasm is not a problem at all, and that's normal! Orgasm may not be the goal!", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"But if you find yourself struggling with this, don't worry, it's well researched and there are ways to help you and your partner!", emotion:characters["profryder"].standingNeutral},
      {text:"Definitely don't blame yourself or try to fake an orgasm", emotion:characters["profryder"].standingSmiling},
      {text:"In sex, it's important that all participants feel good and communicate", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"It is key to talk about what you like and how you like it, guiding your partner", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"And they should try to be receptive and attentive", emotion:characters["profryder"].standingSmiling},
      {text:"All right, I see you can't wait any longer, let's get started!", emotion:characters["profryder"].standingLaughing},
      {text:"First, we need to get our partner aroused", emotion:characters["profryder"].standingSmiling},
      {text:"Foreplay is very important to many women, it allows them to relax and get in the mood to continue", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Stacy, tell me, how would you like to start?", emotion:characters["profryder"].standingSmiling},
      {text:"What turns you on?", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableUnarousedBG,
    phrases:[
      {text:"Well.. I like to be stroked on my thighs and stomach..."},
      {text:"Also... uh.. touching my tits"},
    ]
  },
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableUnarousedLeftBG,
  phrases:[
    {text:"You don't mind if I...", emotion:characters["dick"].neutral, answers:["Touch your tits", "Stroke your thighs"]},
  ]
},
  {option:"Touch your tits", start:true},
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableUnarousedBG,
phrases:[
  {text:"Not at all.."},
]
},
{scene:true, img:stacyTouchingTits, start:true, time:300, dialogCoordinates:"72vh", gallery:gallery[14]},
{scene:true, name:characters["dick"].name, position:"left",
phrases:[
  {text:"Like this?", achievement:achievements[10]},
]},
{scene:true, name:characters["stacy"].name, position:"center",
phrases:[
  {text:"Mm-hmm.."},
  {text:"Yeah.. Like that.."},
  {text:"Please look me in the eyes.."},
  {text:"That's so tender..."},
]},
{scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, dialogCoordinates:"60vh"},
{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableUnarousedRightBG,
phrases:[
  {text:"Very good, Stacy, keep guiding Richard", emotion:characters["profryder"].standingBlushed},
]
},
  {option:"Touch your tits", endOfOption:true},

  {option:"Stroke your thighs", start:true},
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableUnarousedBG,
  phrases:[
  {text:"Not at all.."},
  ]
  },
  {scene:true, img:stacyButtPetting, start:true, time:300, dialogCoordinates:"72vh", gallery:gallery[15]},
  {scene:true, name:characters["dick"].name, position:"left",
  phrases:[
    {text:"Like this?", achievement:achievements[11]},
  ]},
  {scene:true, name:characters["stacy"].name, position:"center",
  phrases:[
    {text:"Ah..."},
    {text:"Not quite what I meant"},
    {text:"But I like the way it feels"},
    {text:"So teasing..."},
  ]},
  {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, dialogCoordinates:"60vh"},
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableUnarousedRightBG,
  phrases:[
    {text:"Stacy, don't be afraid to talk about what you want and guide Richard", emotion:characters["profryder"].standingBlushed},
  ]
  },
  {option:"Stroke your thighs", endOfOption:true, endOfOptions:true},

  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableUnarousedBG,
  phrases:[
    {text:"Uh-huh.."},
  ]
},
  {changeBG:true, img:stacyTeachMasturbation1, smooth:true},
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true,
  phrases:[
    {text:"I... okay, now you can put your hand right here"},
  ]
  },
  {changeBG:true, img:stacyTeachMasturbation2, smooth:true, gallery:gallery[16]},
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true,
  phrases:[
    {text:"And do this.."},
  ]
},
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
  phrases:[
    {text:"Yeah, that's good...", emotion:characters["profryder"].standingBlushed},
    {text:"Umm...", emotion:characters["profryder"].standingBlushed},
    {text:"So, Richard, are you ready?", emotion:characters["profryder"].standingEyebrowsUp, answers:["Sure, I'm a pro!", "I'm ready","I'm a bit nervous..."], warning:"This choice will influence <br/> the practice's difficulty level"},
  ]
  },

  {option:"Sure, I'm a pro!", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"Sure, I'm a pro!", emotion:characters["dick"].smiling},
  ]
},
{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
phrases:[
  {text:"Oh, wow!", emotion:characters["profryder"].standingBlushed},
  {text:"I can't wait to see your skills!", emotion:characters["profryder"].standingBlushed},
]
},

  {option:"Sure, I'm a pro!", endOfOption:true},

  {option:"I'm ready", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"I'm ready", emotion:characters["dick"].smiling},
  ]
},
{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
phrases:[
  {text:"There you go!", emotion:characters["profryder"].standingSmiling},
  {text:"Let's get down to it!", emotion:characters["profryder"].standingSmiling},
]
},
  {option:"I'm ready", endOfOption:true},

  {option:"I'm a bit nervous...", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"Well, actually, I'm a bit nervous...", emotion:characters["dick"].frustrated},
  ]
},
{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
phrases:[
  {text:"Oh, I understand", emotion:characters["profryder"].standingBlushed},
  {text:"I'll be here to help you", emotion:characters["profryder"].standingNeutral},
  {text:"We can stop at any moment if you feel uncomfortable", emotion:characters["profryder"].standingNeutral},
]
},
  {option:"I'm a bit nervous...", endOfOption:true, endOfOptions:true},

  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true,
  phrases:[
    {text:"Mmm"},
    {text:"Mm-hmm"},
    {text:"Just like that.."},
  ]
},

  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
  phrases:[
    {text:"Stacy, now can you let Richard try?", emotion:characters["profryder"].standingBlushed},
    {text:"If that’s okay with you", emotion:characters["profryder"].standingBlushed},
  ]
  },

  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
  phrases:[
    {text:"Yes, sure.."},
    {text:"Got a little carried away.."},
  ]
},

{changeBG:true, img:stacyTeachMasturbation3, smooth:true, gallery:gallery[17]},

{char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
phrases:[
  {text:"You can touch me here"},
]
},
    {endOfNovel:true}
  ]
  },


  {masturbationGame:true},


  //Didn't listen
  {novel:true, background:stacyOnTableArousedRightBG, startCoordinates:20,
  script:[
  {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Richard, you should listen to Stacy very carefully", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"I understand it might be really hard, especially if it's your first time", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"But it's the only way...", emotion:characters["profryder"].standingSmiling},
      {text:"Otherwise you and your partner won't have a good time", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"And that's what we are here for, right?", emotion:characters["profryder"].standingSmiling},
      {text:"If you'd like to try one more time, please ask Stacy if she is ready", emotion:characters["profryder"].standingSmiling},
      {text:"I'll be here to help you both", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
    phrases:[
      {text:"...", emotion:characters["dick"].frustrated, answers:["Can we try one more time?", "It's probably enough for the first time.."]},
    ]
  },

  {option:"Can we try one more time?", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"Sorry, I just got distracted…", emotion:characters["dick"].frustrated},
    {text:"Can we try one more time?", emotion:characters["dick"].frustrated},
  ]
  },
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
  phrases:[
    {text:"Ah, well"},
    {text:"That's all right.. I understand"},
    {text:"Though I'd really love to try again"},
    {text:"<small><i>maybe this time...</small></i>", setNextStep:-1, lastTry:4},
    {text:"But, you know, if I try too many times I can get kinda overstimulated"},
    {text:"So let's make it our last try for today", setNextStep:-1},
  ]
},
  {option:"Can we try one more time?", endOfOption:true},


  {option:"It's probably enough for the first time..", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"I think it's probably enough for the first time..", emotion:characters["dick"].frustrated},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"Oh, I see", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"It's totaly fine to have some time between your attempts", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"The experience you had today is already a lot", emotion:characters["profryder"].standingSmiling},
    {text:"You can get back to it when you both feel ready, okay?", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Stacy, are you okay with that?", emotion:characters["profryder"].standingEyebrowsUp},

  ]
  },
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
  phrases:[
    {text:"Well..."},
    {text:"I'd love to.. um... finish... but"},
    {text:"It's okay"},
    {text:"<small><i>Guess, I'll just do it... on my own</small></i>"},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"That's a good idea, Stacy! Ahah", emotion:characters["profryder"].standingLaughing},
    {text:"Richard, you could do the same..", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
  phrases:[
    {text:"Oh!", emotion:characters["dick"].neutral},
    {text:"...", emotion:characters["dick"].embarassed},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"I can see it was quite exciting for you too!", emotion:characters["profryder"].standingBlushed},
    {text:"You both did a great job today!", emotion:characters["profryder"].standingSmiling},
    {text:"You did it for the first time and in front of the whole class, that tension alone could have gotten in your way", emotion:characters["profryder"].standingNeutral},
    {text:"So don't worry, at least you have had experience and fun!", emotion:characters["profryder"].standingLaughing},
    {text:"All right, guys, you may get back to your seats now", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },

  {char:characters["empty"],  position:"center", coordinates: 70, speed:1,
  phrases:[
    {text:"*Bell ringing sound*"},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
  phrases:[
    {text:"Oh, it's about time!", emotion:characters["profryder"].standingNeutral},
    {text:"That's the end of our lesson for today!", emotion:characters["profryder"].standingSmiling},
    {text:"Please write down a little homework!", emotion:characters["profryder"].standingSmiling},
    {text:"Explore your body, find out what you like", emotion:characters["profryder"].standingSmiling},
    {text:"Experiment!", emotion:characters["profryder"].standingLaughing},
    {text:"You can do this alone or with a partner if you like", emotion:characters["profryder"].standingSmiling},
    {text:"Be ready to share your experience in the next class!", emotion:characters["profryder"].standingSmiling},
    {text:"See you there!", emotion:characters["profryder"].standingLaughing, setNextStep:3}
  ]
  },
  {option:"It's probably enough for the first time..", endOfOption:true, endOfOptions:true},
  {endOfNovel:true}
  ]},

  //Out of stamina
  {novel:true, background:stacyOnTableArousedLeftBG, startCoordinates:20,
  script:[
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Sorry, I just couldn't do it any longer...", emotion:characters["dick"].frustrated},
      {text:"My muscules burn...", emotion:characters["dick"].frustrated},
    ]
  },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
    phrases:[
      {text:"Oh, I see", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Don't worry it's okay", emotion:characters["profryder"].standingLaughing},
      {text:"Especially if it's your first experience", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Your hand will eventually get used to this moves after some time", emotion:characters["profryder"].standingSmiling},
      {text:"Girls often have the same problem while dealing with... penises", emotion:characters["profryder"].standingLaughing},
      {text:"Try to follow Stacy's instructions, but don't forget to adjust the speed so it's also comfortable for you!", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
    phrases:[
      {text:"...", emotion:characters["dick"].frustrated, answers:["Okay, I'll do my best!", "I don't feel like doing it again now"]},
    ]
  },

  {option:"Okay, I'll do my best!", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
  phrases:[
    {text:"Okay, I'll do my best!", emotion:characters["dick"].smiling},
    {text:"Stacy, would you like me to try one more time?", emotion:characters["dick"].frustrated},
  ]
},
{char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
phrases:[
  {text:"Yes..."},
  {text:"It's okay, I totally understand.. he-he"},
  {text:"Let's try again", setNextStep:-2, lastTry:4},
  {text:"But, you know, if I try too many times I can get kinda overheated"},
  {text:"So let it be our last try for today", setNextStep:-2},
]
},
  {option:"Okay, I'll do my best!", endOfOption:true},


  {option:"I don't feel like doing it again now", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
  phrases:[
    {text:"I think it's probably enough for the first time..", emotion:characters["dick"].frustrated},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"Oh, I see", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"It's totaly fine to have some time between your attempts", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"The experience you had today is already a lot", emotion:characters["profryder"].standingSmiling},
    {text:"You can get back to it when you both feel ready, okay?", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Stacy are you okay with that?", emotion:characters["profryder"].standingEyebrowsUp},

  ]
  },
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
  phrases:[
    {text:"Well..."},
    {text:"I'd love to.. um... finish... but"},
    {text:"It's okay"},
    {text:"<small><i>Guess, I'll just do it... on my own</small></i>"},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"That's a good idea, Stacy! Ahah", emotion:characters["profryder"].standingLaughing},
    {text:"Richard, you could do the same..", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
  phrases:[
    {text:"Oh!", emotion:characters["dick"].neutral},
    {text:"...", emotion:characters["dick"].embarassed},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"I can see it was quite exciting for you too!", emotion:characters["profryder"].standingBlushed},
    {text:"You both did a great job today!", emotion:characters["profryder"].standingSmiling},
    {text:"You did it for the first time and in front of the whole class, that tension alone could have gotten in your way", emotion:characters["profryder"].standingNeutral},
    {text:"So don't worry, at least you have had experience and fun!", emotion:characters["profryder"].standingLaughing},
    {text:"All right, guys, you may get back to your seats now", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },

  {char:characters["empty"],  position:"center", coordinates: 70, speed:1,
  phrases:[
    {text:"*Bell ringing sound*"},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
  phrases:[
    {text:"Oh, it's about time!", emotion:characters["profryder"].standingNeutral},
    {text:"That's the end of our lesson for today!", emotion:characters["profryder"].standingSmiling},
    {text:"Please write down a little homework!", emotion:characters["profryder"].standingSmiling},
    {text:"Explore your body, find out what you like", emotion:characters["profryder"].standingSmiling},
    {text:"Experiment!", emotion:characters["profryder"].standingLaughing},
    {text:"You can do this alone or with a partner if you like", emotion:characters["profryder"].standingSmiling},
    {text:"Be ready to share your experience in the next class!", emotion:characters["profryder"].standingSmiling},
    {text:"See you there!", emotion:characters["profryder"].standingLaughing, setNextStep:2}
  ]
  },
  {option:"I don't feel like doing it again now", endOfOption:true, endOfOptions:true},
  {endOfNovel:true}
  ]},

  //Without orgasm
  {novel:true, background:stacyOnTableArousedBG, startCoordinates:50,
  script:[
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true,
    phrases:[
      {text:"Ugh... I can't..."},
      {text:"Let's finish for now"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
    phrases:[
      {text:"That's okay! Let's wrap up the practice for today.", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"At least you got really turned on!", emotion:characters["profryder"].standingBlushed},
      {text:"Haha and not just you!", emotion:characters["profryder"].standingBlushed},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
    phrases:[
      {text:"..?", emotion:characters["dick"].neutralCame},
      {text:"Oh! Sorry..", emotion:characters["dick"].frustratedCame, achievement:achievements[12]},
      {text:"I'm... ugh..", emotion:characters["dick"].frustratedCame},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
    phrases:[
      {text:"That's a perfectly normal reaction! There's nothing to apologize for", emotion:characters["profryder"].standingLaughing},
      {text:"Like I said, the male orgasm is much easier to achieve than the female orgasm", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"And if you're really turned on, it can happen even without stimulation", emotion:characters["profryder"].standingBlushed},
      {text:"Well, you know were to find wet wipes", emotion:characters["profryder"].standingSmiling},
      {text:"By the way, what glands are responsible for lubrication in women?", emotion:characters["profryder"].standingQuestion, answers:["Lesser vestibular glands", "Greater vestibular glands"]},
    ]
    },

    //Lesser vestibular glands
    {option:"Lesser vestibular glands", start:true},
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
    phrases:[
      {text:"Lesse...", emotion:characters["dick"].frustratedCame},
    ]
    },
    {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
    phrases:[
      {text:"Greater vestibular glands!"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
    phrases:[
      {text:"Hahaha, that's right!", emotion:characters["profryder"].standingLaughing},
      {text:"Good teamwork, well done!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {option:"Lesser vestibular glands", endOfOption:true},
    //Greater vestibular glands
    {option:"Greater vestibular glands", start:true},
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Absolutely!", emotion:characters["profryder"].standingEyebrowsUp, achievement:achievements[13]},
      {text:"Well done!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {option:"Greater vestibular glands", endOfOption:true, endOfOptions:true},

    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"You both did a great job today! Thank you!", emotion:characters["profryder"].standingSmiling},
      {text:"You did it for the first time and in front of the whole class, that tension alone could have gotten in your way", emotion:characters["profryder"].standingNeutral},
      {text:"So don't worry, at least you have had experience and fun!", emotion:characters["profryder"].standingLaughing},
      {text:"You guys can sit down, I'll clean up later", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {char:characters["empty"],  position:"center", coordinates: 70, speed:1,
    phrases:[
      {text:"*Bell ringing sound*"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Oh, it's about time!", emotion:characters["profryder"].standingNeutral},
      {text:"That's the end of our lesson for today!", emotion:characters["profryder"].standingSmiling},
      {text:"Please write down a little homework!", emotion:characters["profryder"].standingSmiling},
      {text:"Explore your body, find out what you like", emotion:characters["profryder"].standingSmiling},
      {text:"Experiment!", emotion:characters["profryder"].standingLaughing},
      {text:"You can do this alone or with a partner if you like", emotion:characters["profryder"].standingSmiling},
      {text:"Be ready to share your experience in the next class!", emotion:characters["profryder"].standingSmiling},
      {text:"See you there!", emotion:characters["profryder"].standingLaughing}
    ]
    },
    {endOfNovel:true}
  ]},

  {blackScreen:true, txt:["<h2>*A few minutes later*</h2>"]},

  //Without orgasm
  {novel:true, background:wipingDeskBG, startCoordinates:50,
  script:[
    {char:characters["willie"],  position:"left", coordinates: 0, speed:3, noBlur: true, transitionMode:"slow",
    phrases:[
      {text:"Dude, what's up?", emotion:characters["willie"].snide, gallery:gallery[19]},
      {text:"What's it like?", emotion:characters["willie"].neutral},
      {text:"Touch a real pussy?", emotion:characters["willie"].neutral},
    ]
    },
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Seems like he enjoyed it haha!", emotion:characters["phoebe"].sittingLaughingCoffee},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
    phrases:[
      {text:"Oh, yeah, I can see it hahaha", emotion:characters["willie"].neutral},
      {text:"So, um... let's get going?", emotion:characters["willie"].watchingPhone},
    ]
    },
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Oh, guys, sorry, I'd like to go with you", emotion:characters["phoebe"].sittingNeutralCoffee},
      {text:"But I.. I need to stay for a bit", emotion:characters["phoebe"].sittingNeutralCoffee},
      {text:"I'll probably catch up with you later", emotion:characters["phoebe"].sittingSmilingCoffee, answers:["Is everything okay?", "Okay bye!"]},
    ]
    },

    //Is everything okay?
    {option:"Is everything okay?", start:true},
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Yeah! ", emotion:characters["phoebe"].sittingSmilingCoffee},
      {text:"I just need to ask Ms. Ryder about something...", emotion:characters["phoebe"].sittingThinkingBlushedCoffee},
    ]
    },
    {option:"Is everything okay?", endOfOption:true},

    //Okay bye!
    {option:"Okay bye!", start:true},
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Bye-bye!", emotion:characters["phoebe"].sittingSmilingCoffee},
    ]
    },
    {option:"Okay bye!", endOfOption:true, endOfOptions:true},

    {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
    phrases:[
      {text:"See you tomorrow?", emotion:characters["willie"].neutral},
    ]
    },
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Yep, see you!", emotion:characters["phoebe"].sittingSmilingCoffee},
    ]
    },
    {char:characters["profryder"],  position:"center", coordinates: 20, speed:1, transitionMode:"slow",
    phrases:[
      {text:"Bye, guys!"},
      {text:"Don't forget about your homework!", setNextStep:4},
    ]
    },
    {endOfNovel:true}
  ]},

  //ORGASM
  {novel:true, background:classroomMainCutAfterOrgasm, startCoordinates:20,
  script:[
    {scene:true, img:stacyAfterOrgasm, start:true, time:300, gallery:gallery[18]},
    {scene:true, name:characters["stacy"].name, position:"center",
    phrases:[
      {text:"Oh, god..."},
      {text:"<small><i>Did I...squirted?</small></i>"},
      {text:"I'm so wet..."},
    ]},
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[-7,-5,-7,-5],
    phrases:[
      {text:"Haha and not just you!", emotion:characters["profryder"].standingLaughing},
      {text:"Come here Richard, let's give Stacy some space", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, destinationPoint:[0,-10,0,-10],
    phrases:[
      {text:"..?", emotion:characters["dick"].neutralCameSquirt},
      {text:"Sorry, I'm.. ugh...", emotion:characters["dick"].frustratedCameSquirt, achievement:achievements[12]},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[-7,-5,-7,-5],
    phrases:[
      {text:"That's a perfectly normal reaction! There's nothing to apologize for", emotion:characters["profryder"].standingLaughing},
      {text:"Like I said, the male orgasm is much easier to achieve than the female orgasm", emotion:characters["profryder"].standingSmiling},
      {text:"If you're very turned on, it can happen even without stimulation", emotion:characters["profryder"].standingBlushed},
      {text:"Well, you know were to find wet wipes", emotion:characters["profryder"].standingBlushed},
      {text:"Oh, and Stacy, I think you...", emotion:characters["profryder"].standingSurprised},
      {text:"Squirted...", emotion:characters["profryder"].standingBlushed},
      {text:"Speaking of which, what are the glands responsible for this?", emotion:characters["profryder"].standingEyebrowsUp, answers:["Lesser vestibular glands", "Greater vestibular glands"]},
    ]
    },

    //Lesser vestibular glands
    {option:"Lesser vestibular glands", start:true},
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Absolutely!", emotion:characters["profryder"].standingEyebrowsUp, achievement:achievements[13]},
      {text:"Well done!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {option:"Lesser vestibular glands", endOfOption:true},
    //Greater vestibular glands
    {option:"Greater vestibular glands", start:true},
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Grea...", emotion:characters["dick"].frustratedCameSquirt},
    ]
    },
    {char:characters["stacy"],  position:"center", coordinates: 30, speed:1,
    phrases:[
      {text:"Lesser vestibular glands!"},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Thank you, Stacy!", emotion:characters["dick"].smilingCameSquirted},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Hahaha, right!", emotion:characters["profryder"].standingLaughing},
      {text:"Good teamwork, well done!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {option:"Greater vestibular glands", endOfOption:true, endOfOptions:true},

    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"You both did a great job today! I didn't even expect this result!", emotion:characters["profryder"].standingLaughing},
      {text:"Once again, orgasm is not necessarily achieved from the first time and it is perfectly normal!", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"If you have any difficulties, please contact me!", emotion:characters["profryder"].standingSmiling},
      {text:"Thank you guys, you can sit down now. I'll clean it up later", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["empty"],  position:"center", coordinates: 50, speed:1,
    phrases:[
      {text:"*Bell ringing sound*"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Oh, it's about time!", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"That concludes our lesson for today!", emotion:characters["profryder"].standingSmiling},
      {text:"You’re going to have a little homework!", emotion:characters["profryder"].standingSmiling},
      {text:"Explore your body, find out what you like", emotion:characters["profryder"].standingSmiling},
      {text:"Experiment!", emotion:characters["profryder"].standingLaughing},
      {text:"You can do this alone or with a partner if you like", emotion:characters["profryder"].standingSmiling},
      {text:"Be ready to share your experience in the next class!", emotion:characters["profryder"].standingSmiling},
      {text:"See you later!", emotion:characters["profryder"].standingLaughing}
    ]
    },
    {endOfNovel:true}
]},

{blackScreen:true, txt:["<h2>*A few minutes later*</h2>"]},

{novel:true, background:wipingDeskBG, startCoordinates:50,
script:[
  {char:characters["willie"],  position:"left", coordinates: 0, speed:3, noBlur: true, transitionMode:"slow",
  phrases:[
    {text:"Dude, that was mega-cool!!!", emotion:characters["willie"].neutralSquirt, gallery:gallery[19]},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"It really was...", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
  phrases:[
    {text:"I think I even got one on me!!", emotion:characters["willie"].neutralSquirt},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Is it Stasy's or Dick's? lol", emotion:characters["phoebe"].sittingSnideCoffee},
    {text:"Oh, and we all have wet shirts now! Fair enough!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
  phrases:[
    {text:"YEAH! We are THE WET SQUAD now!!! Ahah", emotion:characters["willie"].neutralSquirt, achievement:achievements[14]},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Like wildly...excited...threesome?", emotion:characters["phoebe"].sittingThinkingCoffee},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
  phrases:[
    {text:"Exactly!", emotion:characters["willie"].neutralSquirt},
    {text:"Soo...", emotion:characters["willie"].watchingPhoneSquirt},
    {text:"Let's get going?", emotion:characters["willie"].neutralSquirt},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Oh, guys, sorry, I'd like to go with you", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"But I.. I need to stay for a bit", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"I'll probably catch up with you later", emotion:characters["phoebe"].sittingSmilingCoffee, answers:["Is everything okay?", "Okay bye!"]},
  ]
  },

  //Is everything okay?
  {option:"Is everything okay?", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Yeah! ", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"I just need to ask Ms. Ryder about something…", emotion:characters["phoebe"].sittingThinkingBlushedCoffee},
  ]
  },
  {option:"Is everything okay?", endOfOption:true},

  //Okay bye!
  {option:"Okay bye!", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Bye-bye!", emotion:characters["phoebe"].sittingSmilingCoffee},
  ]
  },
  {option:"Okay bye!", endOfOption:true, endOfOptions:true},

  {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
  phrases:[
    {text:"See you tomorrow?", emotion:characters["willie"].neutralSquirt},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Yep, see you!", emotion:characters["phoebe"].sittingSmilingCoffee},
  ]
  },
  {char:characters["profryder"],  position:"center", coordinates: 20, speed:1, transitionMode:"slow",
  phrases:[
    {text:"Bye, guys!"},
    {text:"Don't forget about your homework!"},
  ]
  },

  {endOfNovel:true}
]},

{blackScreen:true, txt:["<h2>*That evening*</h2>"]},

{groupChat:true, from:{name:"Group 53X", photo:chatCover, members:8 },
 messages: [
   {text:"Oh yeah.. I can SEE the water was cold!!",from:'messageFromThem', name:"HwrD", avatar:howardChat},
   {img:ryderInsta, height:"450px", from:'messageFromThem', name:"HwrD", avatar:howardChat, gallery:gallery[20]},
   {text:"Give me a link?",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"No that’s for my personal usage!!",from:'messageFromThem', name:"HwrD", avatar:howardChat},
   {text:"Guys, stop it!",from:'messageFromThem', name:"Stacy♡", avatar:stacyChat},
   {text:"Do you have any respect for anyone at all, or at least for yourself?",from:'messageFromThem', name:"Stacy♡", avatar:stacyChat},
   {notification:"Hey! Busy?", vibration:[300], name:"Phoebe", avatar:phoebeChat, endOfChat:true},
]
},

{blackScreen:true, txt:["<h2>It's the end of the second chapter! I hope you enjoyed it! </h2> <br/> Feel free to share your thoughts in comments;)","<h2>Chapter three(Homework) is already available on my Patreon, along with updates on what’s coming next, devlogs, WIPs, feedback polls, and exclusive content!</h2>","<h2>Your support means a lot — it would really help me keep improving the game and creating more content! </br> Thank you!💖</h2>"], end:true},


];

export default chapter2;
